import * as React from 'react';
//Material UI
import {Grid} from '@material-ui/core';
import {
  TextField,
  Modal,
  IconButton,
  Toggle,
  Spinner,
  MessageBarType,
  MessageBar
} from 'office-ui-fabric-react';
//Components
import {DateSelect, PartnerSelect} from '../../../../../../components/Inputs';
import {apiRequest} from './apiRequest';
//Theme
import style from './style';
import { DefaultButton, Label, PrimaryButton } from '@fluentui/react';

const cancelIcon = { iconName: 'Cancel' };

class AddTender extends React.Component{

  constructor(props){
    super(props);
    this.state={
      //tender
      tender:{name:'',description:'',workNumber:'',offerNumber:'',startDate:'',endDate:'',partners:[],showBestOffer:false},
      //request
      loading:false,
      //response
      response:null
    };

    this.onTextChange = this.onTextChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onToggleChange = this.onToggleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.validate = this.validate.bind(this);
    this.validateDate = this.validateDate.bind(this);
  }

  //*Hanlde user interactions*//
  onTextChange(event){
    const {tender} = this.state;
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      tender:{...tender,[name]:value},
      response:null
    });
  }

  onDateChange(name,newDate){
    const {tender} = this.state;
    this.setState({
      tender:{...tender,[name]:newDate},
      response:null
    });
  }

  onSelectChange(items){
    const {tender} = this.state;
    this.setState({
      tender:{...tender,partners:items},
      response:null
    });
  }

  onToggleChange(event,checked){
    const {tender} = this.state;
    this.setState({
      tender:{...tender,showBestOffer:checked},
      response:null
    });
  }
  //**//

  //*Handle actions*//
  handleSave(){
    const {tender} = this.state;
    this.setState({
      response:null,
      loading:true
    });
    let data = {...tender};
    //Convert dates to LocalDate
    data.startDate = this.getLocalDate(new Date(data.startDate.toString()));
    data.endDate = this.getLocalDate(new Date(data.endDate.toString()));
    //Call api
    apiRequest.createTender(this,data);
  }
  //**//

  //*Helper methods*//
  //Helper method to convert Date to UTC
  getLocalDate(date){
    let day = date.getDate();
    let mounth = date.getMonth()+1;
    let year = date.getFullYear();
    return `${day}/${mounth}/${year}`
  }

  validate(){
    const {tender} = this.state;
    if(tender.partners!==null && tender.partners.length>0 && tender.offerNumber!=='' && tender.offerNumber!==undefined && tender.startDate!=='' && tender.endDate!=='' && tender.startDate<=tender.endDate && tender.name!==null && tender.name!==undefined && tender.name!=='')
    {
      return true;
    }
    return false;

  }
  
  validateDate(){
    const {tender} = this.state;
    if(tender.startDate==='' || tender.endDate===''){
      return true;
    }
    if(tender.startDate<=tender.endDate)
    {
      return true;
    }
    return false;
  }

  setMessageBarType(type){
    switch(type){
      case 'success':
        return MessageBarType.success
      case 'warning':
        return MessageBarType.warning
      case 'error':
        return MessageBarType.error
      default: 
        return MessageBarType.error
    }
  }
  //**//

  render(){
    const {tender,loading,response} = this.state;
    const {open,hideModal,partners}=this.props;
    return (
      <Modal
        titleAriaId="edit-modal"
        isOpen={open}
        onDismiss={hideModal}
        isBlocking={false}
        containerClassName={style.contentStyles.container}
      >
        <div className={style.contentStyles.header}>
          <div className={style.contentStyles.titleContent}>
            <div className={style.contentStyles.titleName}>Új kiírás létrehozása</div>
          </div>
          <IconButton
            styles={style.iconButtonStyles}
            iconProps={cancelIcon}
            ariaLabel="Close popup modal"
            onClick={hideModal}
          />
        </div>
        {loading===false &&  <div className={style.contentStyles.body}>
          {response!==null &&
                <MessageBar
                  messageBarType={this.setMessageBarType(response.type)}
                  isMultiline={false}
                >
                {response.message}
                </MessageBar>
            }
          <Grid spacing={2} container>
            <Grid xs={12} sm={12} md={3} lg={3} xl={3} item>
              <TextField required onChange={this.onTextChange} name="name" value={tender.name} label="Megnevezés" description="Rövid megnevezés" />
            </Grid>
            <Grid xs={12} sm={12} md={9} lg={12} xl={12} item>
              <TextField onChange={this.onTextChange} name="description" multiline={true} value={tender.description} label="Leírás" />
            </Grid>
            <Grid xs={12} sm={12} md={3} lg={3} xl={3} item>
              <TextField onChange={this.onTextChange} name="workNumber" value={tender.workNumber} label="Munkaszám" />
            </Grid>
            <Grid xs={12} sm={12} md={3} lg={3} xl={3} item>
              <TextField required={true} onChange={this.onTextChange} name="offerNumber" value={tender.offerNumber} label="Ajánlati szám" />
            </Grid>
            <Grid xs={12} sm={12} md={3} lg={3} xl={3} item>
              <DateSelect required={true}  name="startDate" onChange={this.onDateChange} value={tender.startDate} label="Beadási időszak kezdete"/>
            </Grid>
            <Grid xs={12} sm={12} md={3} lg={3} xl={3} item>
              <DateSelect required={true} errorMessage={this.validateDate() ?  null : 'Nem megengedett érték' } minDate={tender.startDate} name="endDate" onChange={this.onDateChange} value={tender.endDate} label="Beadási időszak vége"/>
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={6} xl={6} item>
                <Label>Partnerek <span style={{color:'rgb(164, 38, 44)'}}>*</span></Label>
                <PartnerSelect required={true} placeholder="Kereséshez kezdj el gépelni..."  onChange={this.onSelectChange} selected={tender.partners} tags={partners} />         
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12} item>
                <Toggle checked={tender.showBestOffer} onChange={this.onToggleChange} label="Legjobb ajánlat mutatása" defaultChecked onText="Igen" offText="Nem" />
              </Grid> 
          </Grid>
        </div>}
        {loading===true && <div className={style.contentStyles.body}>
          <Spinner label="Betöltés..." />
        </div>}
        <div className={style.contentStyles.action}>
          <PrimaryButton disabled={!this.validate() || loading} onClick={this.handleSave} style={{marginRight:'5px'}}>
            Mentés
          </PrimaryButton>
          <DefaultButton onClick={hideModal}>
            Vissza
          </DefaultButton>
        </div>
       
      </Modal>
  );
  }
  
};

export default AddTender;